import React, { Component } from 'react'
import { connect } from 'react-redux'

export function mapStateToProps(state, hocProps) {
    return {
        entity: state.getIn(['ui', 'modules', 'report', 'workspace', hocProps?.id, 'entity']),
        locale: state.getIn(['translate', 'locale']),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
